import { GRADIENT_PRIMARY_CLASS } from '../../foundation/tokens.js';

/**
 * Shell slot (core-shell / Storybook): 36px desktop, border-b y fondo aquí — no en Topbar.
 * Figma 12706:849 — el `<header>` del Topbar va centrado verticalmente con `h-full` dentro de este slot.
 */
export const topbarShellSlotClass = [
  'flex h-topbar w-full shrink-0 items-center border-b border-edge bg-surface px-2',
  'max-md:h-[34px]',
].join(' ');

/** Topbar interior: sin border ni altura fija; ocupa todo el slot padre. */
export const topbarContainerClass =
  'flex h-full w-full items-center justify-between gap-2 bg-transparent max-md:gap-1';

export const topbarLeftZoneClass = [
  'flex h-7 min-w-0 shrink-0 items-center gap-2',
  'w-[140px] px-1 py-0.5',
  'max-md:w-[120px] max-md:gap-1 max-md:px-0',
].join(' ');

export const topbarCenterZoneClass =
  'hidden h-6 shrink-0 items-center justify-center md:flex';

export const topbarRightZoneClass = [
  'flex h-7 shrink-0 items-center gap-2 overflow-visible',
  'min-w-[232px] max-md:min-w-0 max-md:gap-1',
].join(' ');

export const topbarRightGroupAClass = 'flex h-8 shrink-0 items-center gap-1 max-md:h-7';

export const topbarRightActionsClass =
  'flex h-8 shrink-0 items-center gap-1 max-md:h-7';

export const topbarRightGroupBClass = [
  'flex h-7 min-w-[136px] max-w-[200px] shrink-0 items-center overflow-visible px-1 py-0.5',
  'max-md:h-8 max-md:min-w-0 max-md:max-w-none max-md:px-0',
].join(' ');

export const topbarDividerClass = 'h-7 w-px shrink-0 bg-edge max-md:h-8';

export const topbarBrandMarkClass = 'inline-flex h-[19px] w-6 shrink-0 items-center justify-center';

/** Figma 6:8690 — 16px app icon shell (chip derecho / logo custom). */
export const topbarApplicationIconShellClass = [
  'inline-flex h-4 w-4 min-h-[1rem] min-w-[1rem] shrink-0 items-center justify-center',
  'rounded-full border border-[#80AFFF] bg-white text-[#2173FF]',
  'dark:border-blue-400 dark:bg-surface',
].join(' ');

/** Figma 6:8690 — trigger menú izquierdo: círculo blanco + borde #80AFFF (light y dark). */
export const topbarApplicationsMenuIconShellClass = [
  'inline-flex h-4 w-4 min-h-[1rem] min-w-[1rem] shrink-0 items-center justify-center',
  'rounded-full border border-[#80AFFF] bg-white text-[#2173FF]',
  'dark:border-[#80AFFF] dark:bg-white dark:text-[#2173FF]',
].join(' ');

export const topbarHamburgerClass = [
  'inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg',
  'text-content-muted transition-colors md:hidden',
  'hover:bg-surface-hover-subtle hover:text-content',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30',
].join(' ');

export const topbarProfileTriggerClass = [
  'inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-lg',
  'border border-transparent transition-colors',
  'hover:bg-surface-hover-subtle',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30',
].join(' ');

export const topbarChipClass = [
  'inline-flex h-7 max-w-full items-center gap-2 overflow-visible rounded-lg border border-edge px-1.5 py-0.5',
  'bg-surface text-content-secondary transition-colors',
  'hover:bg-surface-hover-subtle focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30',
].join(' ');

/** Figma mobile: identity pill (dual avatars, capsule). */
/** Tenant avatar — same tokens as `TopbarTenantsSection` current tenant row. */
export const topbarTenantAvatarClass = [
  'shrink-0 !border !border-[#99e5f9]',
  '!bg-[#00b5d9]',
  'font-semibold !text-white',
].join(' ');

/** Chip trigger: tenant slightly smaller than profile avatar beside it. */
export const topbarTenantAvatarChipSizeClass =
  '!h-5 !w-5 !min-h-[1.25rem] !min-w-[1.25rem] !text-[9px] md:!h-3.5 md:!w-3.5 md:!min-h-[0.875rem] md:!min-w-[0.875rem] md:!text-[8px]';

export const topbarProfileAvatarChipSizeClass = [
  'shrink-0 border-0 bg-gradient-to-br from-[#2173FF] to-[#80AFFF] font-semibold text-white',
  '!h-6 !w-6 !min-h-[1.5rem] !min-w-[1.5rem] !text-[10px]',
  'md:!h-4 md:!w-4 md:!min-h-[1rem] md:!min-w-[1rem] md:!text-[8px]',
  'md:border md:border-[#80afff] md:bg-none md:!bg-[#2173ff]',
].join(' ');

export const topbarChipIdentityMobileClass = [
  'max-md:h-8 max-md:gap-1 max-md:rounded-full max-md:px-1.5 max-md:py-0.5',
  'max-md:bg-black/[0.2] max-md:border-white/10',
  'dark:max-md:bg-white/[0.06] dark:max-md:border-white/10',
].join(' ');

/** Figma mobile: workspace mark (gradient square). */
export const topbarStudioMarkClass = [
  'inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-[10px] font-semibold leading-none text-white',
  GRADIENT_PRIMARY_CLASS,
].join(' ');

export const topbarChipLabelClass = 'text-[10px] font-semibold leading-none text-content-secondary';

export const topbarIconButtonGhostClass = [
  'inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-md',
  'text-content-muted transition-colors',
  'hover:bg-surface-hover-subtle hover:text-content focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30',
  'max-md:h-8 max-md:w-8 max-md:rounded-lg',
].join(' ');

/** Button variant="primary" — Topbar variant default (botón estrella) */
export const topbarIconButtonAssistantClass = [
  'inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-lg text-white',
  GRADIENT_PRIMARY_CLASS,
  'hover:opacity-90',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#155DFC]/50 focus-visible:ring-offset-2',
  'max-md:h-8 max-md:w-8',
].join(' ');

/** Button variant="primary" — Topbar variant primary */
export const topbarIconButtonAssistantPrimaryClass = [
  'inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-lg text-white',
  GRADIENT_PRIMARY_CLASS,
  'hover:opacity-90',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#155DFC]/50 focus-visible:ring-offset-2',
  'max-md:h-8 max-md:w-8',
].join(' ');

/** Figma mobile: search icon in right toolbar (32×32, subtle fill). */
export const topbarSearchIconTriggerClass = [
  'inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg',
  'bg-black/[0.04] text-content-muted transition-colors',
  'hover:bg-black/[0.06] hover:text-content',
  'dark:bg-white/[0.08] dark:text-gray-400',
  'dark:hover:bg-white/[0.12] dark:hover:text-gray-200',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30',
].join(' ');

export const topbarSearchContainerClass =
  'flex h-6 w-[250px] items-center rounded-lg border border-edge bg-surface px-1';

/** Figma 15416:214885 — panels 320px (w-80) */
export const dropdownPanelClass = [
  'w-80 overflow-hidden rounded-lg border border-edge bg-surface',
  'shadow-[0px_4px_12px_rgba(0,0,0,0.08)]',
].join(' ');

export const dropdownPanelTopDividerClass = 'h-px w-full shrink-0 bg-edge';

export const dropdownMenuHeaderClass =
  'flex h-7 shrink-0 items-center px-4 text-[11px] font-semibold leading-none text-content-secondary';

export const dropdownMenuRow40Class = [
  'flex h-10 w-full shrink-0 items-center gap-4 px-4 text-left',
  'text-[12px] font-medium leading-none text-content-secondary transition-colors',
  'hover:bg-surface-hover-subtle focus-visible:outline-none focus-visible:bg-surface-hover-subtle',
].join(' ');

export const dropdownWorkspaceRowClass = [
  'flex h-14 w-full shrink-0 items-center gap-3 px-4 py-2 text-left transition-colors',
  'hover:bg-surface-hover-subtle focus-visible:outline-none focus-visible:bg-surface-hover-subtle',
].join(' ');

export const dropdownMenuRow50Class = [
  'flex h-[50px] w-full shrink-0 items-center gap-4 px-4 py-2 text-left transition-colors',
  'hover:bg-surface-hover-subtle focus-visible:outline-none focus-visible:bg-surface-hover-subtle',
].join(' ');

export const dropdownAccountRowClass =
  'flex h-[50px] w-full shrink-0 items-center gap-4 px-4 py-2';

export const dropdownDividerClass = 'h-px w-full shrink-0 border-0 bg-edge';

/** Fila flexible (p. ej. bloque Theme con controles a la derecha) */
export const menuRowClass = [
  'flex w-full items-center gap-2 px-4 py-2 text-left text-content-secondary transition-colors',
  'hover:bg-surface-hover-subtle focus-visible:outline-none focus-visible:bg-surface-hover-subtle',
].join(' ');

/** Topbar Sections Buttons 32×32 (Figma 9915:22489) */
export const topbarSectionButtonClass = [
  'relative inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md',
  'text-content-muted transition-colors',
  'hover:bg-surface-hover-subtle hover:text-content',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30',
  'max-md:h-8 max-md:w-8 max-md:rounded-lg',
].join(' ');

export const topbarSectionButtonBadgeClass =
  'absolute right-0 top-0 h-2 w-2 rounded-full bg-red-500';
